// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"_1ioBdv_a_P4tisn44e5vYh","title":"zAOV1FwDVZd9ZZzuyS56","message":"_2Bf5OlCZsMuUuHm_GkJauH","cta":"_1GrWZtjMeMws25iMnZBwQa","supportLink":"_1qT7VrDE4lOBZwzlYpv-AY"};